/**
 * Display heading size, shared by every page title and section heading.
 *
 * Mirrors the `.section-title--display` rule in public/welcome.page.html (the
 * "First-Use Quick Start" heading), so the onboarding page and the app step
 * together: the breakpoints below match that stylesheet's 899px / 599px media
 * queries. Type this size needs its line height pulled in and a little negative
 * tracking, or it opens up and stops reading as one block.
 */
export const displayTitleSx = {
  fontSize: { xs: '2.5rem', sm: '3.25rem', md: '4rem' },
  lineHeight: 1.08,
  letterSpacing: '-0.02em',
};
